const platform = import.meta.env.VITE_PLATFORM

/** 法律文件Text */

export const legalTextEntries = platform === 'topcredit' ? '产品' : '法律文件'

/** 服务条款Text */
export const serviceAgreementTextEntries = platform === 'topcredit' ? '法律与风险披露' : '服务条款'

/** 底部的其他Text */
export const footerOtherTextEntries = platform === 'topcredit' ? '服务' : '其他'
